import { colors } from '../../colors'

interface LoadingIndicatorProps {
  message?: string
  size?: 'small' | 'medium' | 'large'
  className?: string
  style?: React.CSSProperties
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    textAlign: 'center',
    padding: '20px 0',
    marginBottom: '80px',
    color: colors['text-secondary'],
  },
  small: {
    fontSize: '12px',
    padding: '10px 0',
  },
  medium: {
    fontSize: '14px',
    padding: '20px 0',
  },
  large: {
    fontSize: '16px',
    padding: '30px 0',
  },
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  message = '読み込み中...',
  size = 'medium',
  className,
  style,
}) => {
  return (
    <div
      className={className}
      style={{
        ...styles.container,
        ...styles[size],
        ...style,
      }}
    >
      {message}
    </div>
  )
}

export default LoadingIndicator
